import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {API} from "../../../config";
//import {Grid, TableFilterRow, TableHeaderRow, Table, PagingPanel} from "@devexpress/dx-react-grid-material-ui";
//import {FilteringState, IntegratedFiltering, IntegratedSorting, SortingState, TableColumnResizing, PagingState, IntegratedPaging} from "@devexpress/dx-react-grid";
import {connect} from "react-redux";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Util from "../../../yeffect/utils";
const moment = require('moment-timezone');

const rec = API.service('reconcilliation');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    header:{
        backgroundColor:"#262933",
        padding:'18px',
        paddingTop:'17px',
        color:'white'
    },
    flex: {
      flex: 1,
    },
    rec:{
      margin:'100px',
      borderBottom:'1px solid rgba(0,0,0,0.4)',
      borderRight:'1px solid rgba(0,0,0,0.4)',

      '& th':{
        textAlign:'left',
        backgroundColor:'black',
        color:'white',
        padding:'4px'
      },

      '& td':{
        borderLeft:'1px solid rgba(0,0,0,0.4)',
        padding:'4px'
      },

      '& tr:nth-of-type(2n)':{
        backgroundColor:'rgba(0,0,0,0.1)'
      }
    }
});

class BrokerRec extends Component {
    state = {
        recs: false,
        columnWidths: [
          { columnName: 'name', width:190},
          { columnName: 'Statement_Start', width:250},
          { columnName: 'Statement_End', width:60},
          { columnName: 'Start_Balance', width:130},
          { columnName: 'End_Balance', width:240},
          { columnName: 'Rec_Date', width:110},
        ],
        pageSizes: [20,50, 100, 200, 0],
    }

    fetchData = () => {
        const app = this;

        rec.find({query:{incl:'broker'}}).then(r =>{
          console.log('hmmm',r)

            app.setState({
              recs:r.data
            })
            console.log(this.props);
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    componentDidMount = () => {
        this.fetchData();
    }

    changeColumnWidths = (columnWidths) => {
      this.setState({ columnWidths });
    };

    render() {

        const {classes} = this.props;

        return (
            <React.Fragment>

                      <AppBar position="static" elevation={0} style={{boxShadow:'none'}}>
                        <Toolbar>
                          <Typography variant="title" color="inherit" className={classes.flex}>
                            Reconciliations
                          </Typography>
                        </Toolbar>
                      </AppBar>

                  {/*(this.state.recs !== false) &&
                    <Grid
                        rows={this.state.recs}
                        columns={[
                            { name: 'name', title: 'Broker', getCellValue: row => {(row.Authorized_Broker._name) ? row.Authorized_Broker._name : row.AuthorizedBrokerId} },
                            { name: 'Statement_Start', title: 'Statement Start', getCellValue: row => row.statement_start },
                            { name: 'Statement_End', title: 'Statement Start', getCellValue: row => row.statement_end },
                            { name: 'Start_Balance', title: 'Start Balance' , getCellValue: row => row.statement_start_balance},
                            { name: 'End_Balance', title: 'End Balance' , getCellValue: row => row.statement_end_balance},
                            { name: 'Rec_Date', title: 'Rec Date', getCellValue: row => row.complete_date },
                        ]}>
                          <SortingState
                            defaultSorting={[{ columnName: 'Rec_Date', direction: 'desc' }]}
                          />
                          <IntegratedSorting />
                          <FilteringState defaultFilters={[]} />
                          <IntegratedFiltering />
                          <PagingState
                            defaultCurrentPage={0}
                            defaultPageSize={20}
                          />
                          <IntegratedPaging />
                          <Table />
                          <TableColumnResizing defaultColumnWidths={this.state.columnWidths} />
                          <TableHeaderRow showSortingControls />
                          <TableFilterRow />
                          <PagingPanel
                            pageSizes={this.state.pageSizes}
                          />
                      </Grid>
                    */}

                    <table  className={classes.rec} cellSpacing={0} cellPadding={0}>
                      <thead>
                        <tr>
                          <th>Broker</th>
                          <th>Statement Start</th>
                          <th>Statement End</th>
                          <th>Start Balance</th>
                          <th>End Balance</th>
                          <th>Reconciliation Date</th>
                        </tr>
                      </thead>
                      {(this.state.recs !== false) &&
                        <React.Fragment>
                          {this.state.recs.map((row,k)=>{
                            return (
                              <tr>
                                <td>
                                  {(row.Authorized_Broker._name) ? row.Authorized_Broker._name : row.AuthorizedBrokerId}
                                </td>
                                <td>{row.statement_start }</td>
                                <td>{row.statement_end }</td>
                                <td>${Util.addThousandCommas(row.statement_start_balance)}</td>
                                <td>${Util.addThousandCommas(row.statement_end_balance)}</td>
                                <td>{moment(row.complete_date).tz('gmt').format('Y-M-D') }</td>
                              </tr>
                            )
                          })}
                        </React.Fragment>
                      }
                    </table>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(BrokerRec)));



// WEBPACK FOOTER //
// ./src/main/content/broker_rec/BrokerRec.js